import {
  FsHeading,
  HeadingSize,
  HeadingTag,
} from '@printi/ds-offset-react-core';
import styled from 'styled-components';
import { IAttributesHeadSeo } from '@/repositories/aecomStrapiCms/headSeo/types';
import { ContentRenderer } from '@/components/main/ContentRenderer';

const SEOSection = styled.section`
  max-height: 256px;
  overflow-y: auto;
  padding-right: var(--spacing-2x);

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const SEOHeading = styled(FsHeading)`
  margin-bottom: var(--spacing-2x);
`;

const ContentWrapper = styled.div`
  width: 100%;
`;

interface HomeV2SEOProps {
  seoData: IAttributesHeadSeo;
}

export function HomeV2SEO({ seoData }: HomeV2SEOProps) {
  if (!seoData) {
    return null;
  }

  const { title, content } = seoData;

  return (
    <SEOSection>
      <SEOHeading tag={HeadingTag.H2} size={HeadingSize.SM}>
        {title}
      </SEOHeading>
      <ContentWrapper>
        <ContentRenderer content={content} />
      </ContentWrapper>
    </SEOSection>
  );
}
